import axios from "axios";
import config from "../config";
import router from '../router/';
import store from '../store/';

class AuthService {
  isAuthenticated() {
    return store.state.auth.status.loggedIn; //JSON.parse(localStorage.getItem("user"));
  }

  login(payload) {
    return axios
      .post(config.API_URL + "/auth/local", {
        identifier: payload.email,
        password: payload.password
      })
      .then(response => {
        let user = response.data.user;
        user.accessToken = response.data.jwt;
        localStorage.setItem("user", JSON.stringify(user));
        return user;
      })
      .catch(error => {
        return Promise.reject(error); //console.log('An error occurred:', error.response);
      });
  }

  logout() {
    localStorage.removeItem("user");
    router.push("/login");
  }

  register(user) {
    return axios
      .post(config.API_URL + "/auth/local/register", {
        username: user.username,
        email: user.email,
        password: user.password
      })
      .then(response => {
        let user = response.data.user;
        user.accessToken = response.data.jwt;
        localStorage.setItem("user", JSON.stringify(user));
        return user;
      })
      .catch(error => {
        console.log("An error occurred:", error.response);
      });
  }

  resetPassword(payload) {
    return (
      axios
        .post(config.API_URL + "/auth/reset-password", {
          code: payload.code,
          password: payload.password,
          passwordConfirmation: payload.password2
        })
        //       .then(response => {

        //         console.log("Your user's password has been reset.");
        //       })
        .catch(error => {
          console.log("An error occurred:", error.response);
        })
    );
  }

  forgotPassword(payload) {
    return (
      axios
        .post(config.API_URL + "/auth/forgot-password", {
          email: payload.email
        })
        //       .then(response => {

        //         console.log('Your user received an email');
        //       })
        .catch(error => {
          console.log("An error occurred:", error.response);
        })
    );
  }

  sendValidationEmail(payload) {
    return (
      axios
        .post(config.API_URL + '/send-email-confirmation', {
          email: payload.email
        })
        //       .then(response => {
        //         // Handle success.
        //         console.log('Your user received an email');
        //       })
        .catch(error => {
          console.error("An error occured:", error.response);
        })
    );
  }
}

export default new AuthService();
